(function () {
  'use strict';

  var VERSION = '2026-09-04-active-inline-video';
  var MOBILE_QUERY = '(max-width: 749px)';
  var INLINE_VIDEO_SELECTOR = '[data-centauri-c13-inline-video]';
  var VIDEO_TOGGLE_SELECTOR = '[data-centauri-c13-video-toggle]';

  // Theme blocks can emit this asset more than once. A same-version repeat
  // must initialize newly inserted roots without multiplying global resize or
  // Theme Editor listeners.
  if (window.CentauriC13PerformanceCarousel && window.CentauriC13PerformanceCarousel.version === VERSION) {
    window.CentauriC13PerformanceCarousel.init(document);
    return;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function activeVideos(container) {
    var videos = toArray(container.querySelectorAll('video'));
    var mobile = isMobile();
    return videos.filter(function (video) {
      if (video.classList.contains('centauri-rv-desktop')) return !mobile;
      if (video.classList.contains('centauri-rv-mobile')) return mobile;
      return true;
    });
  }

  function syncVideoToggle(container) {
    var button = container.querySelector(VIDEO_TOGGLE_SELECTOR);
    if (!button) return;
    var videos = activeVideos(container);
    var playing = videos.some(function (video) { return !video.paused && !video.ended; });
    var label = button.getAttribute(playing ? 'data-pause-label' : 'data-play-label');
    button.classList.toggle('is-playing', playing);
    button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    if (label) button.setAttribute('aria-label', label);
  }

  function pauseInlineVideo(container) {
    var videos = container.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) videos[i].pause();
    syncVideoToggle(container);
  }

  function playInlineVideo(container) {
    var currentVideos = activeVideos(container);
    var videos = toArray(container.querySelectorAll('video'));

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (currentVideos.indexOf(video) === -1) {
        video.pause();
        continue;
      }
      video.muted = true;
      video.playsInline = true;
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    }

    syncVideoToggle(container);
  }

  function syncInlineVideoPlayback(root) {
    var containers = root.querySelectorAll(INLINE_VIDEO_SELECTOR);
    for (var i = 0; i < containers.length; i++) {
      var panel = containers[i].closest('[data-centauri-aap-panel]');
      var active = panel && (panel.classList.contains('current') || panel.classList.contains('is-active'));
      if (!active) {
        pauseInlineVideo(containers[i]);
      } else if (!containers[i]._centauriC13UserPaused) {
        playInlineVideo(containers[i]);
      }
    }
  }

  function wireInlineVideos(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var containers = [];
    if (base.matches && base.matches(INLINE_VIDEO_SELECTOR)) containers.push(base);
    containers = containers.concat(toArray(base.querySelectorAll(INLINE_VIDEO_SELECTOR)));

    for (var i = 0; i < containers.length; i++) {
      (function (container) {
        if (container._centauriC13InlineVideoReady) {
          syncVideoToggle(container);
          return;
        }
        var button = container.querySelector(VIDEO_TOGGLE_SELECTOR);
        if (!button) return;
        var videos = toArray(container.querySelectorAll('video'));
        var toggleHandler = function (event) {
          event.preventDefault();
          event.stopPropagation();
          var currentVideos = activeVideos(container);
          var playing = currentVideos.some(function (video) { return !video.paused && !video.ended; });
          if (playing) {
            container._centauriC13UserPaused = true;
            pauseInlineVideo(container);
            return;
          }
          container._centauriC13UserPaused = false;
          playInlineVideo(container);
        };
        var stateHandler = function () { syncVideoToggle(container); };
        button.addEventListener('click', toggleHandler);
        for (var videoIndex = 0; videoIndex < videos.length; videoIndex++) {
          videos[videoIndex].addEventListener('play', stateHandler);
          videos[videoIndex].addEventListener('pause', stateHandler);
          videos[videoIndex].addEventListener('ended', stateHandler);
        }
        container._centauriC13InlineVideoReady = true;
        container._centauriC13InlineVideoTeardown = function () {
          button.removeEventListener('click', toggleHandler);
          for (var cleanupIndex = 0; cleanupIndex < videos.length; cleanupIndex++) {
            videos[cleanupIndex].removeEventListener('play', stateHandler);
            videos[cleanupIndex].removeEventListener('pause', stateHandler);
            videos[cleanupIndex].removeEventListener('ended', stateHandler);
          }
          container._centauriC13InlineVideoReady = false;
          container._centauriC13InlineVideoTeardown = null;
        };
        syncVideoToggle(container);
      })(containers[i]);
    }
  }

  function teardownInlineVideos(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var containers = [];
    if (base.matches && base.matches(INLINE_VIDEO_SELECTOR)) containers.push(base);
    containers = containers.concat(toArray(base.querySelectorAll(INLINE_VIDEO_SELECTOR)));
    for (var i = 0; i < containers.length; i++) {
      pauseInlineVideo(containers[i]);
      if (containers[i]._centauriC13InlineVideoTeardown) containers[i]._centauriC13InlineVideoTeardown();
    }
  }

  function syncMobileCards(root) {
    var panels = root.querySelectorAll('[data-centauri-aap-panel]');
    var mobile = isMobile();
    for (var i = 0; i < panels.length; i++) {
      var active = panels[i].classList.contains('current');
      if (mobile) {
        panels[i].setAttribute('aria-hidden', active ? 'false' : 'true');
      } else {
        panels[i].removeAttribute('aria-hidden');
      }
    }
  }

  function wireMobileCards(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (base.matches && base.matches('[data-centauri-aap-gallery]')) roots.push(base);
    var found = base.querySelectorAll('[data-centauri-aap-gallery]');
    for (var rootIndex = 0; rootIndex < found.length; rootIndex++) roots.push(found[rootIndex]);
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        if (root._centauriC13MobileCardsReady) {
          syncMobileCards(root);
          syncInlineVideoPlayback(root);
          return;
        }
        var observer = new MutationObserver(function () {
          syncMobileCards(root);
          syncInlineVideoPlayback(root);
        });
        var focusHandler = function (event) {
          if (!isMobile()) return;
          if (event.target && event.target.closest && event.target.closest(VIDEO_TOGGLE_SELECTOR)) return;
          // A focused control or link inside a card must never be hidden by
          // automatic AAP advancement. Keep the user's reading/focus context
          // stable until they explicitly resume playback.
          if (window.CentauriAAPGallery && typeof window.CentauriAAPGallery.pause === 'function') {
            window.CentauriAAPGallery.pause(root);
          }
        };
        observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
        root.addEventListener('focusin', focusHandler);
        root._centauriC13MobileCardsReady = true;
        root._centauriC13MobileCardsTeardown = function () {
          observer.disconnect();
          root.removeEventListener('focusin', focusHandler);
          root._centauriC13MobileCardsReady = false;
          root._centauriC13MobileCardsTeardown = null;
        };
        syncMobileCards(root);
        syncInlineVideoPlayback(root);
      })(roots[i]);
    }
  }

  function teardownMobileCards(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (base.matches && base.matches('[data-centauri-aap-gallery]')) roots.push(base);
    var found = base.querySelectorAll('[data-centauri-aap-gallery]');
    for (var i = 0; i < found.length; i++) roots.push(found[i]);
    for (var j = 0; j < roots.length; j++) {
      if (roots[j]._centauriC13MobileCardsTeardown) roots[j]._centauriC13MobileCardsTeardown();
    }
  }

  function init(scope) {
    if (window.CentauriAAPGallery && typeof window.CentauriAAPGallery.init === 'function') {
      window.CentauriAAPGallery.init(scope || document);
    }
    wireInlineVideos(scope || document);
    wireMobileCards(scope || document);
  }

  function teardown(target) {
    teardownInlineVideos(target || document);
    teardownMobileCards(target || document);
    if (window.CentauriAAPGallery && typeof window.CentauriAAPGallery.teardown === 'function') {
      window.CentauriAAPGallery.teardown(target);
    }
  }

  function goTo(target, index) {
    if (window.CentauriAAPGallery && typeof window.CentauriAAPGallery.goTo === 'function') {
      if (typeof index === 'undefined') {
        window.CentauriAAPGallery.goTo(target);
        return;
      }
      window.CentauriAAPGallery.goTo(target, index);
    }
  }

  window.CentauriC13ScrollTabs = {
    version: VERSION,
    init: init,
    teardown: teardown,
    goTo: goTo
  };

  window.CentauriC13PerformanceCarousel = {
    version: VERSION,
    init: init,
    teardown: teardown
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.addEventListener('resize', function () {
    wireInlineVideos(document);
    wireMobileCards(document);
  }, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
  document.addEventListener('shopify:section:unload', function (event) { teardown(event.target); });
})();
